<template>
  <div class="onboarding-step">
    <Hero
      v-if="image"
      :image="image"
    />
    <div class="onboarding-step__text">
      <Heading
        :label="`${index + 1}/${ totalSteps }`"
        :title="title"
        :subtitle="subtitle"
      />
      <Wysiwyg
        :content="content"
      />
    </div>
  </div>
</template>

<script>
import Hero from '@/sections/section-header/SectionHeader'
import Heading from '@/components/heading/Heading'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'

export default {
  name: 'OnboardingStep',
  components: {
    Hero,
    Heading,
    Wysiwyg
  },
  props: {
    totalSteps: {
      type: Number,
      default: 1
    },
    image: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  }
}
</script>
